import React, { useState, useRef, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import ReCAPTCHA from 'react-google-recaptcha';
import { Security as SecurityIcon } from '@mui/icons-material';
import { Host } from '../../../assets/js/Host';
import { useSelector } from 'react-redux';

const CaptchaDialog = ({ 
  open, 
  onClose, 
  onVerify, 
  loading = false
}) => {
  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaError, setCaptchaError] = useState(false);
  const [serverLoading, setServerLoading] = useState(false);
  const [isServerVerified, setIsServerVerified] = useState(false);
  const recaptchaRef = useRef(null);
  const themeData = useSelector((state) => state.themeData);

  // Customize Arabic text for reCAPTCHA
      try {
        const captcha = recaptchaRef?.current?.querySelector(
          "#recaptcha-anchor-label"
        );
        if (captcha) {
          captcha.textContent = "أنا لست روبوتًا";
        }
      } catch (e) {
        console.log('Could not customize captcha text:', e);
      }
  const handleCaptchaChange = (token) => {
    console.log("Captcha value:", token);
    try {
      setCaptchaToken(token);
      setCaptchaError(false);
    } catch (error) {
      console.error('Error in handleCaptchaChange:', error);
      setCaptchaError(true);
    }
  };

  const handleCaptchaExpired = () => {
    try {
    setCaptchaToken(null);
    setCaptchaError(true);
  } catch (error) {
    console.error('Error in handleCaptchaExpired:', error);
    setCaptchaError(true);
  }
  };

  const handleSubmit = () => {
    try {
      if (!captchaToken) {
        setCaptchaError(true);
        return;
      }
      onVerify(captchaToken);
    } catch (error) {
      console.error('Error in handleSubmit:', error);
      setCaptchaError(true);
    }
  };

  const reloadCaptcha = () => {
    try {
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
      setCaptchaToken(null);
      setCaptchaError(false);
    } catch (error) {
      console.error('Error reloading captcha:', error);
    }
  };

  const handleClose = () => {
    try {
      setCaptchaToken(null);
      setCaptchaError(false);
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
      onClose();
    } catch (error) {
      console.error('Error in handleClose:', error);
      setCaptchaError(true);
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 1
        }
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}>
          <SecurityIcon color="primary" sx={{ fontSize: 32, mr: 1 }} />
          <Typography variant="h6" component="span" sx={{color:"#000",
          fontFamily:"Cairo"
          }}>
            {'التحقق الامني'}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary"
          sx={{
            fontFamily:"Cairo"
          }}
        >
          {'يرجى إكمال التحقق الأمني ​​لإرسال النموذج الخاص بك'}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 3,marginTop:'10px'}}>
        <Box
          sx={{
            backgroundColor: '#fff',
            // boxShadow: '0 0px 7px -2px #ac9f9f',
            padding: '30px 25px',
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            marginTop:'10px'
          }}
        >
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={Host.CAPATCHA_SECRET_KEY}
            onChange={handleCaptchaChange}
            onExpired={handleCaptchaExpired}
            onError={() => setCaptchaError(true)}
            hl='ar'
          />
          
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center',fontFamily:"Cairo" }}>
            {'يرجى الانتظار أثناء تحميل CAPTCHA'
            }
          </Typography>
          
            <Button
              onClick={reloadCaptcha}
              variant="contained"
              sx={{
                fontFamily:"Cairo",
                backgroundColor: themeData?.maintheme?.primaryColor || '#1e6a99',
                color: '#fff',
                '&:hover': {
                  backgroundColor: themeData?.maintheme?.primaryColor || '#155a85'
                }
              }}
            >
              { 'إعادة تحميل CAPTCHA'
              }
            </Button>
        
        </Box>
        
        {captchaError && (
          <Typography 
            variant="body2" 
            color="error" 
            sx={{ mt: 2, textAlign: 'center' ,fontFamily:"Cairo"}}
          >
            {'الرجاء إكمال التحقق من الكابتشا'}
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'space-between', pb: 2 }}>

          <Button 
            onClick={handleSubmit}
            variant="contained"
            disabled={!captchaToken || loading}
            startIcon={(loading) ? <CircularProgress size={20} /> : null}
            sx={{
              fontFamily:"Cairo"
            }}
          >
            {(loading)
              ? 'تقديم...'
              : ('إرسال النموذج')
            }
          </Button>
          <Button 
          onClick={handleClose} 
          variant="outlined"
          disabled={loading || serverLoading}
          sx={{
            fontFamily:"Cairo"
          }}
        >
          {'الغاء'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CaptchaDialog;
